// extracted by mini-css-extract-plugin
export default {"secondaryCategorySeoLinks":"secondaryCategorySeoLinks_et0Wk"};